import React from 'react'
import Footer from '../defaultComponents/Footer'

import styled from 'styled-components'

import TextField from '@mui/material/TextField';

import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6347',
    },
  },
});

const PageWrapper = styled.div`
  font-family: Inter;
`

const TitleBanner = styled.div`
  display: flex;
  justify-content: center;
`

const TitleBox = styled.div`
  font-size: 2rem;
  font-family: Montserrat;
  font-weight: bold;
  width: 90vw;
  padding-left: 2vw;
`

const AssetSearchBanner = styled.div`
  display: flex;
  justify-content: center;
`

const AssetSearchBox = styled.div`
  width: 90vw;
  padding: 2vh 2vw 0vh 2vw;

  display: flex;
  gap: 1vw;
  flex-direction: row;
  > * {
    flex: 1;
  }

  @media (max-width: 700px) {
    width: 80vw;
    flex-direction: column;
  }
`

const AssetClearBanner = styled.div`
  display: flex;
  justify-content: center;
`

const AssetClearSearchBox = styled.div`
  width: 90vw;
  padding: 2vh 2vw 0vh 2vw;

  @media (max-width: 700px) {
    width: 80vw;
  }
`

const AssetClearSearchButton = styled.button`
  width: 150px;
  border: 2px solid lightgrey;;
  border-radius: 3px;
  background: lightgrey;
  font-weight: bold;
  color: #333333;
  padding: 5px 0vw 5px 0vw;
  &:hover {
    background: #505050;
    border-color: #606060;
    color: #FFFFFF;
  }
`

const AssetDashBanner = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const AssetBoxContainer = styled.div`
  min-height: 60vh;
  width: 90vw;
  gap: 1vw;
  padding: 2vw 2vw 2vw 2vw;

  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 700px) {
    grid-template-columns: repeat(1, 1fr);
    width: 80vw;

    height: 70vh;
    overflow: auto;

    margin-top: 20px;

    padding-bottom: 200px;
  }
`

const AssetBox = styled.div`
  border: 1px solid #E3E4E6;
  border-radius: 5px;
  background: white;

  display: flex;
  font-family: Inter;

  padding-top: 1vh;
  padding-bottom: 1vh;

  height: 250px;

  @media (min-width: 701px) {
    &:hover{
      transform: scale(1.05);
      border-color: black;
    }
  }

  @media (max-width: 700px) {

    height: 200px;
    padding-left: 10px;
  }
`

const AssetImage = styled.div`
  background: papayawhip;
  min-width: 40%;

  display: flex;
  justify-content: center;
  align-items: center;
`

const AssetName = styled.div`
  font-size: 1.8rem;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: 700px) {
    font-size: 1rem;
  }
`

const AssetInfoBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  padding: 1vh 1vw 1vh 1vw;
`

const AssetUserInfo = styled.div`
  color: grey;
  font-weight: bold;
  font-size: 1rem;

  text-transform: uppercase;
  @media (max-width: 700px) {

    font-size: 1rem;
  }
`

export default function AssetReturnsStock() {

  // Handling the hired data 
  const [assets, setAssets] = React.useState([])
  const [displayData, setDisplayData] = React.useState([])

  const getAssets = async () => {
    try {
      const res = await fetch("https://ic360portalbackend.azurewebsites.net/api/InternalAssets/AssetStock");

      const data = await res.json();

      // console.log(JSON.stringify(data));
      setAssets(data)
      setDisplayData(data)
    } catch (error) {
      console.error("Error getting hired data")
    }
  }

  React.useEffect(() => {
    getAssets()
  }, [])

  // -- Search Bar for employees

  const [filters, setFilters] = React.useState({
    assetName: "",
  })

  const [searchAsset, setSearchAsset] = React.useState("")

  React.useEffect(() => {
    const applyFilters = () => {
      let filteredData = assets;

      if (filters.assetName) {
        setSearchAsset(filters.assetName)
        filteredData = filteredData.filter(entry =>
          entry.asset_name.toLowerCase().includes(filters.assetName.toLowerCase())
        );
      } else {
        setSearchAsset("")
      }
      setDisplayData(filteredData);
    };

    applyFilters();
  }, [filters, assets]);

  const handleSearch = (value, field) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      assetName: "",
    })
  }

  return (<>
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <TitleBanner>
          <TitleBox>STOCK</TitleBox>
        </TitleBanner>
        <AssetSearchBanner>
          <AssetSearchBox>
            <TextField
              variant="outlined"
              placeholder="Asset Name"
              onChange={(e) => { handleSearch(e.target.value, "assetName") }}
              value={searchAsset}
            />
          </AssetSearchBox>
        </AssetSearchBanner>

        <AssetClearBanner>
          <AssetClearSearchBox>
            <AssetClearSearchButton onClick={() => { handleClearFilters() }}>Clear Filters</AssetClearSearchButton>
          </AssetClearSearchBox>

        </AssetClearBanner>

        <AssetDashBanner>
          <AssetBoxContainer>
            {displayData.map((asset) => (
              <AssetBox key={asset.asset_id}>
                <AssetImage>PICTURE</AssetImage>
                <AssetInfoBox>
                  <div>
                    <AssetName>{asset.asset_name}</AssetName>
                  </div>
                  <AssetUserInfo>stock: {asset.in_stock_quantity} / {asset.asset_total_stock}</AssetUserInfo>
                </AssetInfoBox>

                
              </AssetBox>
            ))}
          </AssetBoxContainer>
        </AssetDashBanner>
        <Footer />
      </PageWrapper>
    </ThemeProvider>
  </>)
}
